// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h6 {
	color: var(--dark-text-color);
	font-size: 20px;
	font-weight: bold;
	line-height: 28px;
	font-family: "Poppins", sans-serif !important;
	letter-spacing: 0.0075em;
}

h6 hr {
	width: 24px;
	border: none;
	height: 3px;
	margin: 6px auto 0 0;
	background: var(--primary-color);
}

.customer_desc {
	color: var(--desc-color);
	font-size: 16px;
	font-weight: 400;
	line-height: 32px;
	font-family: Verdana, sans-serif !important;
	letter-spacing: 0.00938em;
	margin: 16px 0 8px 0;
}

.ExistingCustomer_otr .theme_input {
	margin-bottom: 24px;
}

.error-border {
	border: 1px solid red;
}

.customer_note, .error_note {
	color: var(--black-color);
	font-size: 12px;
	line-height: 24px;
	font-family: "Poppins", sans-serif !important;
	font-weight: 700;
	letter-spacing: 0.00938em;
}

.error_note {
	font-style: italic;
	font-weight: 400;
	color: gray;
	margin: 3px 0px 15px 0px;
}

.error_text {
	color: var(--primary-color);
}

.error_text:hover {
	text-decoration: underline;
	cursor: pointer;
}

.customer_note .note_text {
	font-family: Verdana, sans-serif !important;
	font-weight: 100 !important;
	margin-left: 4px;
}

.ChangeAddressStep_otr {
	position: relative;
}
.ChangeAddressStep_otr {
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 24px;
	padding: 16px 24px;
	/* overflow-y: scroll; */
	/* height: 1000px; */
}

.ChangeAddressStep_otr .header_heading {
	color: var(--dark-text-color);
	font-size: 20px;
	font-weight: bold;
	line-height: 28px;
	font-family: "Poppins", sans-serif !important;
	letter-spacing: 0.0075em;
}

.ChangeAddressStep_otr .header_heading hr {
	width: 24px;
	border: none;
	height: 3px;
	margin: 6px auto 0 0;
	background: var(--primary-color);
}

.ChangeAddressStep_otr .radio_check_group {
	display: flex;
	flex-direction: column;
	/* gap: 24px; */
	gap: 1.5rem;
	padding-top: 0.875rem;
	max-height: calc(100vh - 350px);
	overflow-y: auto;
}

.ChangeAddressStep_otr .radio_check_group .ant-radio-wrapper {
	justify-content: flex-start !important;
	width: 100%;
}

.ChangeAddressStep_otr .action_otr {
	display: flex;
}

.ChangeAddressStep_otr .address_button {
	border: 1px solid var(--primary-color);
	background-color: var(--primary-light);
	color: var(--primary-color) !important;
	font-family: "Poppins", sans-serif;
	font-weight: 700;
	padding: 6px 20px;
	letter-spacing: 0.02957rem;
	border-radius: 50px;
	-webkit-border-radius: 50px;
	-moz-border-radius: 50px;
	-ms-border-radius: 50px;
	-o-border-radius: 50px;
	cursor: pointer;
	transition: 0.3s;
	-webkit-transition: 0.3s;
	-moz-transition: 0.3s;
	-ms-transition: 0.3s;
	-o-transition: 0.3s;
}

.ChangeAddressStep_otr .address_button:hover {
	background-color: var(--primary-light2) !important;
}
.modal_main {
	position: absolute;
	top: 0;
	left: -100%;
	width: 100%;
	height: calc(100vh - 186px);
	/* height: 100%; */
	background-color: var(--black-opacity-40);
	z-index: 10;
	overflow-y: auto;
	opacity: 1;
	visibility: hidden;
	transition: 0.3s;
	-webkit-transition: 0.3s;
	-moz-transition: 0.3s;
	-ms-transition: 0.3s;
	-o-transition: 0.3s;
}

.modal_main::-webkit-scrollbar {
	width: 6px;
}

.modal_main::-webkit-scrollbar-thumb {
	background: #a3a3a3;
}

.modal_show {
	left: 0;
	opacity: 1;
	visibility: visible;
}

.modal_main .modal_content {
	position: absolute;
	width: calc(100% - 48px);
	z-index: 2;
	margin: 32px 24px 0 24px;
}

.modal_main .modal_content .close_icon_otr {
	position: absolute;
	top: 10px;
	right: 10px;
	width: 24px;
	height: 24px;
	padding: 0;
	border: none;
	z-index: 10;
	cursor: pointer;
	background-color: transparent;
}

.modal_main .modal_content .close_icon_otr svg {
	width: 24px;
	height: 24px;
}

.modal_main .modal_content .close_icon_otr svg path {
	fill: var(--dark-text-color);
}

.modal_main .modal_content .AddressStep_otr {
	background-color: white;
	border-radius: 16px;
	-webkit-border-radius: 16px;
	-moz-border-radius: 16px;
	-ms-border-radius: 16px;
	-o-border-radius: 16px;
	box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 34px;
	padding: 24px 30px;
	margin-bottom: 32px;
}

.modal_main .AddressStep_otr .customer_heading {
	display: none;
}

.modal_main .AddressStep_otr .customer_desc:nth-child(2) {
	margin-top: 0;
}

.editor-content {
	margin-top: 10px;
	word-break: normal;
	line-height: 1.5;
}

.editor-content p {
	margin-bottom: 12px;
	display: inline;
}

.editor-content a {
	text-decoration: none;
	display: inline;
	word-break: normal;
}

.editor-content a:hover {
	text-decoration: underline;
}

.editor-content br {
	display: block;
	margin: 8px 0;
	content: "";
}

.customer_note {
	display: block;
	font-weight: 600;
	margin-bottom: 8px;
}

.note_text {
	display: block;
	margin-top: 8px;
	color: var(--desc-color);
}
`, "",{"version":3,"sources":["webpack://./src/Components/ClientInfo/ExistingCustomer/ExistingCustomer.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,6CAA6C;CAC7C,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,oBAAoB;CACpB,gCAAgC;AACjC;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,2CAA2C;CAC3C,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,6CAA6C;CAC7C,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,wBAAwB;AACzB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,2CAA2C;CAC3C,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,kBAAkB;CAClB,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,6CAA6C;CAC7C,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,oBAAoB;CACpB,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,WAAW;CACX,qBAAqB;CACrB,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,sCAAsC;CACtC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,sCAAsC;CACtC,sCAAsC;CACtC,sCAAsC;CACtC,kCAAkC;CAClC,gBAAgB;CAChB,iBAAiB;CACjB,0BAA0B;CAC1B,mBAAmB;CACnB,2BAA2B;CAC3B,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;CACtB,eAAe;CACf,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,kDAAkD;AACnD;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,WAAW;CACX,2BAA2B;CAC3B,kBAAkB;CAClB,yCAAyC;CACzC,WAAW;CACX,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,OAAO;CACP,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,wBAAwB;CACxB,UAAU;CACV,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,WAAW;CACX,YAAY;CACZ,UAAU;CACV,YAAY;CACZ,WAAW;CACX,eAAe;CACf,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,2BAA2B;CAC3B,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;CACtB,6CAA6C;CAC7C,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,wBAAwB;AACzB","sourcesContent":["h6 {\n\tcolor: var(--dark-text-color);\n\tfont-size: 20px;\n\tfont-weight: bold;\n\tline-height: 28px;\n\tfont-family: \"Poppins\", sans-serif !important;\n\tletter-spacing: 0.0075em;\n}\n\nh6 hr {\n\twidth: 24px;\n\tborder: none;\n\theight: 3px;\n\tmargin: 6px auto 0 0;\n\tbackground: var(--primary-color);\n}\n\n.customer_desc {\n\tcolor: var(--desc-color);\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tline-height: 32px;\n\tfont-family: Verdana, sans-serif !important;\n\tletter-spacing: 0.00938em;\n\tmargin: 16px 0 8px 0;\n}\n\n.ExistingCustomer_otr .theme_input {\n\tmargin-bottom: 24px;\n}\n\n.error-border {\n\tborder: 1px solid red;\n}\n\n.customer_note, .error_note {\n\tcolor: var(--black-color);\n\tfont-size: 12px;\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif !important;\n\tfont-weight: 700;\n\tletter-spacing: 0.00938em;\n}\n\n.error_note {\n\tfont-style: italic;\n\tfont-weight: 400;\n\tcolor: gray;\n\tmargin: 3px 0px 15px 0px;\n}\n\n.error_text {\n\tcolor: var(--primary-color);\n}\n\n.error_text:hover {\n\ttext-decoration: underline;\n\tcursor: pointer;\n}\n\n.customer_note .note_text {\n\tfont-family: Verdana, sans-serif !important;\n\tfont-weight: 100 !important;\n\tmargin-left: 4px;\n}\n\n.ChangeAddressStep_otr {\n\tposition: relative;\n}\n.ChangeAddressStep_otr {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\tpadding: 16px 24px;\n\t/* overflow-y: scroll; */\n\t/* height: 1000px; */\n}\n\n.ChangeAddressStep_otr .header_heading {\n\tcolor: var(--dark-text-color);\n\tfont-size: 20px;\n\tfont-weight: bold;\n\tline-height: 28px;\n\tfont-family: \"Poppins\", sans-serif !important;\n\tletter-spacing: 0.0075em;\n}\n\n.ChangeAddressStep_otr .header_heading hr {\n\twidth: 24px;\n\tborder: none;\n\theight: 3px;\n\tmargin: 6px auto 0 0;\n\tbackground: var(--primary-color);\n}\n\n.ChangeAddressStep_otr .radio_check_group {\n\tdisplay: flex;\n\tflex-direction: column;\n\t/* gap: 24px; */\n\tgap: 1.5rem;\n\tpadding-top: 0.875rem;\n\tmax-height: calc(100vh - 350px);\n\toverflow-y: auto;\n}\n\n.ChangeAddressStep_otr .radio_check_group .ant-radio-wrapper {\n\tjustify-content: flex-start !important;\n\twidth: 100%;\n}\n\n.ChangeAddressStep_otr .action_otr {\n\tdisplay: flex;\n}\n\n.ChangeAddressStep_otr .address_button {\n\tborder: 1px solid var(--primary-color);\n\tbackground-color: var(--primary-light);\n\tcolor: var(--primary-color) !important;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 700;\n\tpadding: 6px 20px;\n\tletter-spacing: 0.02957rem;\n\tborder-radius: 50px;\n\t-webkit-border-radius: 50px;\n\t-moz-border-radius: 50px;\n\t-ms-border-radius: 50px;\n\t-o-border-radius: 50px;\n\tcursor: pointer;\n\ttransition: 0.3s;\n\t-webkit-transition: 0.3s;\n\t-moz-transition: 0.3s;\n\t-ms-transition: 0.3s;\n\t-o-transition: 0.3s;\n}\n\n.ChangeAddressStep_otr .address_button:hover {\n\tbackground-color: var(--primary-light2) !important;\n}\n.modal_main {\n\tposition: absolute;\n\ttop: 0;\n\tleft: -100%;\n\twidth: 100%;\n\theight: calc(100vh - 186px);\n\t/* height: 100%; */\n\tbackground-color: var(--black-opacity-40);\n\tz-index: 10;\n\toverflow-y: auto;\n\topacity: 1;\n\tvisibility: hidden;\n\ttransition: 0.3s;\n\t-webkit-transition: 0.3s;\n\t-moz-transition: 0.3s;\n\t-ms-transition: 0.3s;\n\t-o-transition: 0.3s;\n}\n\n.modal_main::-webkit-scrollbar {\n\twidth: 6px;\n}\n\n.modal_main::-webkit-scrollbar-thumb {\n\tbackground: #a3a3a3;\n}\n\n.modal_show {\n\tleft: 0;\n\topacity: 1;\n\tvisibility: visible;\n}\n\n.modal_main .modal_content {\n\tposition: absolute;\n\twidth: calc(100% - 48px);\n\tz-index: 2;\n\tmargin: 32px 24px 0 24px;\n}\n\n.modal_main .modal_content .close_icon_otr {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n\twidth: 24px;\n\theight: 24px;\n\tpadding: 0;\n\tborder: none;\n\tz-index: 10;\n\tcursor: pointer;\n\tbackground-color: transparent;\n}\n\n.modal_main .modal_content .close_icon_otr svg {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.modal_main .modal_content .close_icon_otr svg path {\n\tfill: var(--dark-text-color);\n}\n\n.modal_main .modal_content .AddressStep_otr {\n\tbackground-color: white;\n\tborder-radius: 16px;\n\t-webkit-border-radius: 16px;\n\t-moz-border-radius: 16px;\n\t-ms-border-radius: 16px;\n\t-o-border-radius: 16px;\n\tbox-shadow: rgba(0, 0, 0, 0.25) 0px 14px 34px;\n\tpadding: 24px 30px;\n\tmargin-bottom: 32px;\n}\n\n.modal_main .AddressStep_otr .customer_heading {\n\tdisplay: none;\n}\n\n.modal_main .AddressStep_otr .customer_desc:nth-child(2) {\n\tmargin-top: 0;\n}\n\n.editor-content {\n\tmargin-top: 10px;\n\tword-break: normal;\n\tline-height: 1.5;\n}\n\n.editor-content p {\n\tmargin-bottom: 12px;\n\tdisplay: inline;\n}\n\n.editor-content a {\n\ttext-decoration: none;\n\tdisplay: inline;\n\tword-break: normal;\n}\n\n.editor-content a:hover {\n\ttext-decoration: underline;\n}\n\n.editor-content br {\n\tdisplay: block;\n\tmargin: 8px 0;\n\tcontent: \"\";\n}\n\n.customer_note {\n\tdisplay: block;\n\tfont-weight: 600;\n\tmargin-bottom: 8px;\n}\n\n.note_text {\n\tdisplay: block;\n\tmargin-top: 8px;\n\tcolor: var(--desc-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
